export default __webpack_public_path__ + "static/media/Look Fit.9f4dcb22.png";